import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('address-type-switcher', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./address-type-switcher')
    ),
);
